import { render } from "./ToastNotify.vue?vue&type=template&id=c36d8ec6"
import script from "./ToastNotify.vue?vue&type=script&lang=js"
export * from "./ToastNotify.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__